module.exports = __webpack_public_path__ + "4602d2d238ebfab30d425c29f861093f.jpg";